(function () {
  'use strict';

  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  /* ---------- Gallery: arrows, thumbnails, swipe ---------- */
  function initGallery(root) {
    var slides = qsa(root, '.vm-slide');
    var thumbs = qsa(root, '.vm-thumb');
    var stage = qs(root, '.vm-stage');
    if (!slides.length) return;
    var current = 0;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-on', n === current);
      });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-on', n === current);
      });
      if (thumbs[current] && thumbs[current].scrollIntoView) {
        try {
          thumbs[current].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } catch (e) {}
      }
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () {
        show(n);
      });
    });
    var prev = qs(root, '[data-vm-prev]');
    var next = qs(root, '[data-vm-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    if (slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    if (stage) {
      var startX = null;
      stage.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) show(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }
  }

  /* ---------- Offers + letter slots + add to cart ---------- */
  function initForm(form) {
    var radios = qsa(form, 'input[name="vm_offer"]');
    var slotsWrap = qs(form, '[data-vm-slots]');
    var slotEls = slotsWrap ? qsa(slotsWrap, '.vm-slot') : [];
    var errEl = qs(form, '[data-vm-error]');
    var root = form.closest('[data-vm-product]') || document;
    var cartUrl = form.getAttribute('data-cart-url') || '/cart';
    var defaultVariant = form.getAttribute('data-default-variant');
    var buttons = [qs(form, '.vm-atc'), qs(root, '.vm-stickybar')].filter(Boolean);

    function checked() {
      return radios.filter(function (r) { return r.checked; })[0];
    }

    function applySlots(n) {
      if (slotsWrap) {
        slotsWrap.style.gridTemplateColumns = 'repeat(' + n + ', minmax(0, 1fr))';
        slotsWrap.style.maxWidth = n === 1 ? '240px' : '100%';
      }
      slotEls.forEach(function (slot, i) {
        var hide = i >= n;
        slot.hidden = hide;
        var sel = qs(slot, 'select');
        var lab = qs(slot, '[data-vm-slot-label]');
        if (sel) {
          sel.disabled = hide;
          sel.required = !hide;
        }
        if (lab) lab.textContent = n === 1 ? lab.getAttribute('data-one') : lab.getAttribute('data-many') + ' ' + (i + 1);
      });
      var head = qs(form, '[data-vm-letter-head]');
      if (head) head.textContent = n === 1 ? head.getAttribute('data-one') : head.getAttribute('data-many');
    }

    function onChange() {
      radios.forEach(function (r) {
        var box = r.closest('.vm-offer');
        if (box) box.classList.toggle('is-on', r.checked);
      });
      var c = checked();
      if (c) applySlots(parseInt(c.getAttribute('data-slots') || '1', 10));
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = !msg;
    }

    function missingMsg(slot) {
      var lab = slot ? qs(slot, '[data-vm-slot-label]') : null;
      var pfx = lab ? (lab.getAttribute('data-many') || '') : '';
      if (!pfx || /necklace/i.test(pfx)) return 'Please choose a letter for every necklace.';
      return 'Please choose a color for every ' + pfx.toLowerCase() + '.';
    }

    function setBusy(busy) {
      buttons.forEach(function (b) { b.disabled = busy; });
    }

    radios.forEach(function (r) { r.addEventListener('change', onChange); });
    onChange();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showError('');
      var c = checked();
      var n = c ? parseInt(c.getAttribute('data-slots') || '1', 10) : 1;
      var label = c ? c.getAttribute('data-label') : '';
      var items = [];

      if (slotEls.length) {
        var i;
        for (i = 0; i < n; i++) {
          var sel = qs(slotEls[i], 'select');
          if (!sel || !sel.value) {
            if (sel) {
              sel.classList.add('is-bad');
              sel.focus();
            }
            showError(missingMsg(slotEls[i]));
            return;
          }
          sel.classList.remove('is-bad');
          var item = { id: Number(sel.value), quantity: 1 };
          if (n > 1) item.properties = { Offer: label };
          items.push(item);
        }
      } else {
        var one = { id: Number(defaultVariant), quantity: n };
        if (n > 1) one.properties = { Offer: label };
        items.push(one);
      }

      /* Extra lines chosen in add-on blocks on the same page (e.g. the letter set). */
      var extra = [];
      if (typeof window.vmExtraItems === 'function') {
        try { extra = window.vmExtraItems(form) || []; } catch (ex) { extra = []; }
      }

      setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: extra.slice().reverse().concat(items.slice().reverse()) })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
            return data;
          });
        })
        .then(function () {
          if (extra.length && typeof window.vmExtraAdded === 'function') {
            try { window.vmExtraAdded(form); } catch (ex) {}
          }
          if (window.vmCart && window.vmCart.open) {
            setBusy(false);
            window.vmCart.open();
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function (err) {
          setBusy(false);
          showError(err.message || 'Could not add to cart. Please try again.');
        });
    });

    qsa(form, '.vm-sel').forEach(function (sel) {
      sel.addEventListener('change', function () {
        sel.classList.remove('is-bad');
        showError('');
      });
    });
  }

  /* ---------- Cart count ---------- */
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa(document, '[data-vm-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = !cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---------- Upsell add to cart + colour dots ---------- */
  function initUpsell(root) {
    qsa(root, '[data-vm-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var row = dot.closest('[data-vm-up]');
        if (!row) return;
        qsa(row, '[data-vm-dot]').forEach(function (d) { d.classList.remove('is-on'); });
        dot.classList.add('is-on');
        var btn = qs(row, '[data-vm-add]');
        if (btn) {
          btn.setAttribute('data-variant', dot.getAttribute('data-variant'));
          btn.disabled = dot.getAttribute('data-available') === 'false';
        }
        var lab = qs(row, '[data-vm-dot-label]');
        if (lab) lab.textContent = dot.getAttribute('data-label');
      });
    });
    qsa(root, '[data-vm-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant');
        if (!id || btn.classList.contains('is-added')) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            btn.textContent = btn.getAttribute('data-added') || 'ADDED';
            btn.classList.add('is-added');
            btn.disabled = false;
            refreshCount();
            if (window.vmCart && window.vmCart.refresh) window.vmCart.refresh();
          })
          .catch(function () {
            btn.disabled = false;
          });
      });
    });
  }

  function once(fn) {
    return function (el) {
      if (el.getAttribute('data-vm-ready')) return;
      el.setAttribute('data-vm-ready', '1');
      fn(el);
    };
  }

  function init() {
    qsa(document, '[data-vm-menu-btn]').forEach(once(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }));
    qsa(document, '[data-vm-gallery]').forEach(once(initGallery));
    qsa(document, '[data-vm-form]').forEach(once(initForm));
    qsa(document, '[data-vm-upsell]').forEach(once(initUpsell));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
